// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Sort } from '@/constants/sort';
import {
  ContactFilter,
  ContactSortProperty,
  getContacts,
} from '@/contact/api/get-contacts';
import { ONE_MINUTE_MS, TWO_MINUTES_MS } from '@/utilities/time-constants';
import { useSuspenseQuery } from '@tanstack/react-query';

const DEFAULT_SORT: Sort<ContactSortProperty> = {
  property: 'name',
  direction: 'asc',
};

interface UseContactsOptions {
  sort?: Sort<ContactSortProperty>;
  filter?: ContactFilter;
  page?: number;
  pageSize?: number;
}

export function useContacts(options: UseContactsOptions = {}) {
  const sort = options.sort ?? DEFAULT_SORT;
  const page = options.page ?? 1;
  const pageSize = options.pageSize ?? 25;

  const { data, ...query } = useSuspenseQuery({
    queryKey: ['contact', options.filter, sort, page, pageSize],
    queryFn: () =>
      getContacts({
        filter: options.filter,
        sort,
        page,
        limit: pageSize,
      }),
    refetchOnWindowFocus: true,
    staleTime: ONE_MINUTE_MS,
    refetchInterval: TWO_MINUTES_MS,
  });

  return {
    contacts: data.contacts,
    totalCount: data.totalCount,
    ...query,
  };
}
